import { GitRemoteApi } from 'osep-generator-service-client-v1';
import { SPDX_LICENSES_KEY } from '../../utils/consts';
import { useApiConfig } from '../useApiConfig';
import { useQuery } from '@tanstack/react-query';

function useGetSPDXLicenses() {
  const { getApiConfig, axiosInstance } = useApiConfig();

  return useQuery({
    queryKey: [SPDX_LICENSES_KEY],
    queryFn: async () => {
      const config = await getApiConfig();
      const api = new GitRemoteApi(config, undefined, axiosInstance);

      const result = (await api.getSpdxLicenses()).data;

      return result;
    },
  });
}

export default useGetSPDXLicenses;
